import { createReducer, on, createFeature, provideState } from '@ngrx/store';
import { VaSessionActions } from './va-session.actions';
import { AuthTokenActions } from '../auth-token/auth-token.actions';
import { makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { VaSessionEffects } from './va-session.effects';

export const initialState: Readonly<VaSessionState> = {
  sessionIdentifier: '',
  expiryDate: null,
  isSessionExpired: false,
};

export const vaSessionFeature = createFeature({
  name: 'vaSession',
  reducer: createReducer(
    initialState,
    on(
      AuthTokenActions.startSessionSuccess,
      (state, { expiryDate, sessionIdentifier }) => {
        return { ...state, expiryDate: expiryDate, sessionIdentifier };
      }
    ),
    on(VaSessionActions.expireSession, (state) => {
      return { ...state, isSessionExpired: true };
    }),
    on(VaSessionActions.setSessionValid, (state) => {
      return { ...state, isSessionExpired: false };
    })
  ),
});

export const {
  selectVaSessionState,
  selectExpiryDate,
  selectSessionIdentifier,
  selectIsSessionExpired,
} = vaSessionFeature;

export function provideVaSessionFeature() {
  return makeEnvironmentProviders([
    provideState(vaSessionFeature),
    provideEffects(VaSessionEffects),
  ]);
}
